module.exports = __webpack_public_path__ + "img/green-gb-login.fffa1bde.jpg";